<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 9117px;background: url('https://p1.fishqc.net/FveqPieQLBsJLMmEVbr9HeAgzKQY') center center no-repeat;background-size: auto 100%;padding-top: 548px;box-sizing: border-box;">
                    <div class="contain_2022_315" style="width:1128px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:533727;height: 100%;text-align: center;">
                        <div class="title_315">
                            买得省心、用得放心、吃得安心，生活才会舒心。小鱼315好物清单，科学测评为你保驾护航，守护你的健康生活。
                        </div>
                        <div>
                            <div v-for="val in productDatas" class="box_paddingtop">
                                <img :src="val.titleImg">
                                <div class="subtitle_315">{{val.desc}}</div>
                                <div class="productcontain_315" v-for="item in val.productarr">
                                    <div class="title_3">{{item.title}}</div>
                                    <div class="producttype_desc">{{item.desc}}</div>
                                    <div class="display_flex justify-content_flex-justify padding_30_315">
                                        <div v-for="productItem in item.product" class="productbox_315 display_flex justify-content_flex-justify" @click="toproductdetail(productItem.type,productItem.id)">
                                            <div class="productImg" :style="{backgroundImage: 'url('+ productItem.img + ')'}">
                                                <div>
                                                    <img src="https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I" class="greenIcon">
                                                </div>
                                            </div>
                                            <div style="text-align: left;flex:1;padding-bottom: 56px;box-sizing: border-box;" class="display_flex justify-content_flex-justify derection-column">
                                                <div>
                                                    <div class="brand_315">{{productItem.brand}}</div>
                                                    <div class="producttitle_315" v-html="productItem.title">{{productItem.title}}</div>
                                                    <div v-if="productItem.effect" style="padding-top: 10px;box-sizing: border-box;">
                                                        <img src="https://p1.fishqc.net/Fu_RDE3tRhCtzoIy8iJWNqcjn27I">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="tips_315">{{productItem.tips}}</div>
                                                    <div class="address_315">品牌所在地：{{productItem.address}}</div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="padding-top:50px;box-sizing: border-box;">
                            <img src="https://p1.fishqc.net/FkJ3pLqX_Xd9Cl78LveO-hcmBVkJ" alt="">
                        </div>
                        <div style="padding-top:228px;box-sizing: border-box;">
                            <img src="https://p1.fishqc.net/FuRZE7-JVFZAbP3Elp9XwZfvCFj2" alt="">
                        </div>
                       <!--  <div class="descbox">
                            315一天的放心，是远远不够的。365天的安心，才是我们想要的。小鱼让你315不踩雷，选好放心优品安心每一天。
                        </div>
                        <div v-for="item in productdata">
                            <div class="padding_top_60">
                                <img :src="item.typeImg">
                            </div>
                            <div class="typeItem">
                                {{item.dec}}
                                <img src="http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt" class="typeItem_bg">
                                
                            </div>
                            <div class="productItem_315" v-for="val in item.section">
                                <div class="productItem_type_title">{{val.title}}</div>
                                <div class="productItem_type_desc">{{val.destext}}</div>
                                <div class="display_flex justify-content_flex-justify" style="padding:0 62px 50px;box-sizing: border-box;">
                                    <div class="double12_product display_flex flex-wrap_wrap " v-for="itemindex in val.product"  @click="toproductdetail(itemindex.type,itemindex.id)">
                                        <div class="double12_img">
                                            <div class="product_img" :style="{backgroundImage: 'url('+ itemindex.img + ')'}">
                                                <img class="greenfish" src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK">
                                            </div>
                                            
                                        </div>
                                        <div class="double12_producttxt flex_1">
                                            <div>{{itemindex.brand}}</div>
                                            <div class="producttxt_name">{{itemindex.title}}</div>
                                            <div class="tips_padding">
                                                <span class="double12_tips">{{itemindex.tips}}</span>
                                            </div>
                                            <div>
                                                <span class="double12_address">品牌所在地：{{itemindex.address}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div style="padding-top: 20px;box-sizing: border-box;">
                            <img src="http://p1.fishqc.net/Fqo2Z6wMtxAy9TOdPffaq2UtBCNV">
                        </div>
                        <div style="padding-top: 100px;box-sizing: border-box;">
                            <img src="http://p1.fishqc.net/Fiqplwa00FMo6aQNaEMUuccD0jmN">
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 1937px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(255,117,131,0.3);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    background:#FFF7F5;
    border-radius:24px;
    padding:0 32px 60px;
    margin-bottom: 60px;

}


.munbox:last-child{
    margin-bottom: 0px;
}
.producttype{
    display:inline-block;
    width:178px;
    height:48px;
    line-height: 48px;
    color:#fff;
    font-size:24px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    background: -webkit-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -o-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -moz-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -ms-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -webkit-gradient(linear, 0% 100%, from(rgba(254,99,72,1)), to(rgba(255,139,119,1)));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,99,72,1)), color-stop(100%,rgba(255,139,119,1)));
    background:linear-gradient(0deg,rgba(254,99,72,1),rgba(255,139,119,1));
    box-shadow: 0px 0px  8px #FFAD9D;
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:24px 0;
    box-sizing:border-box;
    color:#444a46;
    font-size:24px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
}

.dec-text{
    font-size:18px;
    color:#494947;
    line-height:30px;
    text-indent:3px;
    text-align:left;
    padding:20px 32px;
    background-color:#fff;
    border-radius:20px;
    position:relative;
    margin-bottom: 35px;
    
}
.tips{
    width: 174px;
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-20px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    
}
.tipstext{
    display:inline-block;
    font-size:24px;
    color:#fff;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(225,251,248,1);
}

.productdetailcontain{
    width: 273px;
    margin-right: 60px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 402px;
    vertical-align: top;
    /*margin-bottom: 32px;*/
    cursor: pointer;
    padding:0 40px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 24px rgba(255,117,131,0.06);

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(3n){
    margin-right: 0px;
}

.imgcontain{
    width:100%;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:14px;
    bottom:0px;
}
.class1{
    height: 130%;
    /*width:238px;*/
}
.class2{
    height: 100%;
    /*width:120px;*/
}
.class3{
    height: 100%;
    /*width:157px;*/
}
.class4{
    /*width:218px;*/
    height: 114%;
}
.class5{
    /*width:140px;*/
    height: 100%;
}
.class6{
    /*width:106px;*/
    height: 100%;
}
.class7{
    /*width:119px;*/
    height: 100%;
}
.class8{
    /*width:200px;*/
    height: 100%;
}
.class9{
    /*width:200px;*/
    height: 120%;
}
.class10{
    /*width:210px;*/
    height: 120%;
}

.class11{
    /*width:82px;*/
    height: 100%;
}
.class12{
    /*width:110px;*/
    height: 100%;

}
.class13{
    /*width:172px;*/
    height: 100%;
}
.class14{
    /*width:128px;*/
    height: 100%;
}
.class15{
    /*width:76px;*/
    height: 100%;

}
.class16{
    /*width:158px;*/
    height: 112%;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:20px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

.title{
    font-size:18px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 20px;
}

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 16px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.techcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.heightclass1{
    height: 392px;
}
.heightclass2{
    height: 392px;
    margin-right:0;
}
.heightclass3{
    height: 470px;
}

.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 256px;
}

.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}
.padding-top-495 {
    padding-top: 495px;
}

.double11_head {
    width: 1000px;
    box-sizing: border-box;
    font-size: 26px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FEAE50;
    line-height: 48px;

    background-color: #fff;
    text-align: center;
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
}

.double11_back {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0);
    width: 958px;
    height: 70px;
    background-image: url('http://p1.fishqc.net/Fnbl0MTCI_lcZufbh51TuOICg5-u');
    background-repeat: no-repeat;
    background-position: center center;

}

.font-weight-bold {
    font-weight: bold;


}

.padding-top-46 {
    padding-top: 46px;
    text-align: center;
}

.double11_desc1 {
    padding-top: 14px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
}

.double11_bg {
    width: 1078px;
    background-image: url('http://p1.fishqc.net/FrSI1Mebdl0WDMyxfdhmR0g89YMC');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.double11_list {
    width: 1000px;
    margin-top: 82px;
    background-color: #fff;
    padding: 26px 30px 50px;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
    position: relative;
}

.shadow-bottom {
    position: absolute;
    bottom: 30px;
    left: 0;
    z-index: 1
}

.double11_txt {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #544F4D;
    text-align: center;
    line-height: 48px;
    text-align: left;
}

.double11_item {
    width: 454px;
    height: 161px;
    background: #FFFFFF;
    border: 1px solid #EEEAF0;
    margin-right: 27px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
}

.double11_item:nth-of-type(2n) {
    margin-right: 0;
}

.double11_item:nth-of-type(1) {
    margin-top: 6px;
}

.double11_item:nth-of-type(2) {
    margin-top: 6px;
}

.double11_list2 {
    margin-top: 92px;
    line-height: 48px;
    text-align: left;
}

.double11_list2 .double11_txt {
    text-align: left
}

.padding-top-110 {
    padding-top: 110px;
    text-align: center;
}

.double11_item_left {
    width: 160px;
    height: 100%;
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.double11_item_left .productimg {
    width: 140px;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.double11_item_right {
    width: 280px;
    height: 100%;
    display: inline-block;
    position: relative;
    padding-right: 20px;
    box-sizing: border-box;

}

.double11_item_right .title {
    padding-top: 25px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #3F3E3A;
    line-height: 30px;
    padding-bottom: 18px;
    text-align: left;
}

.double11_address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #666666;
    line-height: 17px;
}

.double11_label {
    width: 98px;
    height: 30px;
    background: #FDF2E3;
    text-align: center;
    line-height: 30px;

    font-size: 17px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEAE82;
}

.greenfish {
    width: 64px;
    height: 64px;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.double_top_title {
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translate(-50%, 0);
}
/**/
.descbox{
    height: 138px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 44px;
    padding: 24px 130px 0 100px;
    box-sizing: border-box;
    text-align: left;
}

.padding_top_60{
    padding-top: 60px;
    box-sizing: border-box;
}

.typeItem{
    height: 138px;
    background: #355CD0;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FEFFFF;
    line-height: 44px;
    text-align: left;
    padding:24px 116px 0 102px;
    box-sizing: border-box;
    position: relative;
}
.typeItem_bg{
    position: absolute;
    width:1116px;
    height: 121px;
    background: url('http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt');
    background-size: contain;
    background-repeat: no-repeat;
    left: -56px;
    top: -78px;
}
    
.productItem_315{
    background: #EDFFFC;
    box-shadow: 0px 0px 8px 1px rgba(83, 116, 215, 0.29);
    border-radius: 24px;
    position: relative;
    margin-top: 78px;
    padding-top:52px;
    box-sizing: border-box;
    box-shadow: 0px 0px 12px 20px #24409314;
}

.productItem_type_title{
    width: 335px;
    height: 62px;
    background-image: url('http://p1.fishqc.net/FsFAr9gnZ3fl22TIaTazjL7T3LRS');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    line-height: 62px;
    text-align: center;
    position: absolute;
    left:50%;
    top:-31px;
    transform: translate(-50%,0);
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3844BA;
}

.productItem_type_desc{
    width: 936px;
    margin:0 auto 30px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(115, 228, 209, 0.21);
    border-radius: 16px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 30px;
    padding:18px 32px 14px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_product{
    width: 454px;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 1px 8px 0px rgba(205, 247, 218, 0.7);
    border-radius: 24px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_producttxt{
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #58BA96;
    text-align: left;
    padding-top: 40px;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 26px;
}

.double12_address{

    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 43px;
}

.double12_img{
    width: 154px;
    width: 200px;
    height: 254px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;

}
.tips_padding{
    padding-top: 50px;
    padding-bottom: 24px;
    box-sizing: border-box;
}
.double12_tips{
    line-height: 16px;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #44CCBD;
    padding:6px 14px;
    box-sizing: border-box;
    background: #D2F2EE;
    opacity: 0.7;
    border-radius: 16px 0px 16px 0px;
    
}

.decclass{
    width: 880px;
}
.decclass1{
    width: 660px;
}
.greenfish{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: 24px;
    right: 0px;

}
.producttxt_name{
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    padding-top: 10px;
    box-sizing: border-box;
}

.product_img{
    width: 154px;
    height: 205px;
    margin-top: 30px;
    margin-left:20px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
}

/*315*/
.contain_2022_315{
    .title_315{
        width: 1048px;
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
        padding-bottom: 90px;
        box-sizing: border-box;
    }

    .productcontain_315{
        width: 1128px;
        height: 591px;
        background: url('https://p1.fishqc.net/FpKU6ZUcyOBY9RJtdrIb6kpdC5RV') center center no-repeat;
        background-size: contain;
        padding: 0 34px;
        box-sizing: border-box;
    }

    .subtitle_315{
        padding-top: 48px;
        box-sizing: border-box;
        width: 1028px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
    }

    .box_paddingtop{
        padding-top:64px;
        box-sizing: border-box;
        &:first-child{
            padding-top: 0;
        }
    }

    .title_3{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FEFEFE;
        line-height: 70px;
        text-shadow: 1px 2px 3px #76AFC4;
        padding-top: 34px;
        box-sizing: border-box;
    }

    .producttype_desc{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        padding: 30px 30px 0px;
        box-sizing: border-box;
    }

    .productbox_315{
        width: 488px;
        height: 270px;
        background: #FFFFFF;
        border-radius: 24px;
        cursor: pointer;
    }

    .padding_30_315{
        padding: 26px 30px;
        box-sizing: border-box;
    }
    .productImg{
        width: 202px;
        height: 100%;
        background-position: center center;
        background-size: 90%;
        background-repeat: no-repeat;
        position: relative;
    }

    .brand_315{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #10227C;
        line-height: 24px;
        padding-top: 37px;
        box-sizing: border-box;
    }
    .producttitle_315{
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #10227C;
        line-height: 22px;
        padding-top: 8px;
    }
    .tips_315{
        line-height: 16px;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        background-color: #FFFCA0;
        padding:6px 14px;
        box-sizing: border-box;
        color: #FF7E00;
        opacity: 0.7;
        border-radius: 16px 0px 16px 0px;
        display: inline-block;
    }

    .address_315{
        padding-top: 10px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #10227C;
        line-height: 16px;
    }

    .greenIcon{
        width: 88px;
        height: 88px;
        position: absolute;
        bottom: 20px;
        right: 10px;
    }
}

</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            
            productDatas:[
                {
                    titleImg:'https://p1.fishqc.net/FoboqaO_JCEAAmIuprhtOWMXyoq2',
                    desc:'女生们最关心的是护肤品的安全了，天天使用稍有不慎伤害皮肤又影响身体健康，认准绿鱼，美得放心。',
                    productarr:[
                        {
                            title:'精华',
                            desc:'精华液中的营养物质能够由肌肤表面进入到肌肤的基底层，发挥作用。根据皮肤的需求选择合适安全的精华极其重要。',
                            product:[{
                                img: 'https://p1.fishqc.net/FuDfpDVvrmbYukMFXuxtOt7Jynyk',
                                brand: "PURID 朴理",
                                title: '2号创研修护焕漾二号精华液',
                                tips: '抗红御氧',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                                effect:true
                      
                            },{
                                img: 'https://p1.fishqc.net/FoPiuShmnjkBCr4gz9DGlWVaTYbt',
                                brand: "DECORTE黛珂",
                                title: '莹润粹白璇亮菁华液',
                                tips: '匀白透亮',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'h5LBDZFWWgR7W287E052Wg',
                      
                            }]
                        },{
                            title:'爽肤水',
                            desc:'爽肤水浸润调理角质层，使肌肤更好地吸收后续的保养品，打好保养护肤的基础更要选择安全的爽肤水产品。',
                            product:[{
                                img: 'https://p1.fishqc.net/FkTBDX2JTSlNI1gwH1AbleE8rwZV',
                                brand: "My Clorisland 花皙蔻",
                                title: ' 洛神花细致毛孔精华水',
                                tips: '混油皮必备',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'BgdaLLepToHrcHu00hNxTg',
                      
                            },{
                                img: 'https://p1.fishqc.net/FoX8BUTUHesQkfV7tV3NLAu1NpG0',
                                brand: "IPSA茵芙莎 ",
                                title: '流金岁月凝润美肤水',
                                tips: '保湿净白',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'MJuXaYg7_IxfTpA-NDtfEA',
                      
                            }]
                        },{
                            title:'防晒',
                            desc:'日晒与紫外线，不仅会引起皮肤损伤，黑色素沉着，更重要是使皮肤老化。选择安全的绿鱼防晒更安心。',
                            product:[{
                                img: 'https://p1.fishqc.net/FrAHKukH-vRHCeOpCSDxFrvpADfJ',
                                brand: "DECORTE黛珂 ",
                                title: '多重防晒乳',
                                tips: '高倍防晒',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'b64OKxCsDJ_HEfG3t5woQg',
                      
                            },{
                                img: 'https://p1.fishqc.net/FkP4KpUA_dpAecGoqBF38JlFVI8C',
                                brand: "NIVEA妮维雅",
                                title: '水感防日光保湿啫喱<br>SPF50 PA+++',
                                tips: '平价大碗',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'H1RwxIoptj0LO0Tiasdtbg',
                            }]
                        }
                    ]

                },
                {
                    titleImg:'https://p1.fishqc.net/FtR6Z9CKXuFq0eGvCPZyRdEcyXYz',
                    desc:'母婴用品曝光的安全问题屡见不鲜，孕妈和孩子的用品更要选择安全好物，才能安心每一天。',
                    productarr:[
                        {
                            title:'孕妇保健品',
                            desc:'各种孕期产品鱼龙混杂，孕期营养更需慎重，某些劣质营养素可能会危害胎儿和妈妈的健康，跟着绿鱼榜单选，全家安心。',
                            product:[{
                                img: 'https://p1.fishqc.net/FuDbfEpxBs2FQewuVfTavARJZV5h',
                                brand: "BLACKMORES澳佳宝",
                                title: '孕妇黃金营养素',
                                tips: '营养丰富',
                                address: '澳大利亚',
                                type: 'food',
                                id: 'cW_N74C4g-mLLUkKwhq9vw',
                      
                            },{
                                img: 'https://p1.fishqc.net/FrWYPomo8XnXMbJZxm544Lrtmp74',
                                brand: "GNC健安喜",
                                title: '孕妇营养包含维生素+钙+DHA<br>全面综合营养30天配方 - 钙',
                                tips: '高含量钙',
                                address: '美国',
                                type: 'food',
                                id: '5xjBClrf0YW4FolgC34zMg',
                            }]
                        },{
                            title:'儿童牙膏',
                            desc:'不同于成人刷牙只需清洁到位，宝宝刷牙容易吞咽牙膏，选择成分安全的儿童牙膏就至关重要，看准好物榜单不踩雷。',
                            product:[{
                                img: 'https://p1.fishqc.net/FqOkMifjLAPRGIt04CujX6O3Zlez',
                                brand: "INTELLIGENT因特力净",
                                title: '儿童酵素牙膏',
                                tips: '酵素洁净',
                                address: '中国台湾',
                                type: 'cosmetic',
                                id: 'JSnuGpfbq0FTPOGhm8AolQ',
                      
                            },{
                                img: 'https://p1.fishqc.net/FhfXyKUEu1QbmLuwjkFKCufegrpF',
                                brand: "PIGEON贝亲",
                                title: '婴儿防蛀牙膏(木糖醇口味)',
                                tips: '防龋固齿',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'j4uzKG8E1EV36guypo-kMw',
                            }]
                        },{
                            title:'儿童零食',
                            desc:'小鱼数据库中，大部分不达标零食产品均是类雌激素过高，容易导致性早熟，智商降低，癌症等，选绿鱼优品才放心。',
                            product:[{
                                img: 'https://p1.fishqc.net/FoB1Pzw9BfXgiP9ayzg4kJGsd9h0',
                                brand: "SUNRYPE",
                                title: '果肉水果条 72条',
                                tips: '营养美味',
                                address: '加拿大',
                                type: 'food',
                                id: 'Yxh79H1iSWh7qzqBiYeNoA',
                      
                            },{
                                img: 'https://p1.fishqc.net/FnqfwSD0BhOrBYqLGZZN0hfFQl9_',
                                brand: "HEINZ亨氏",
                                title: '谷物磨牙棒（香橙/蔬菜/牛奶）',
                                tips: '纯净天然',
                                address: '美国',
                                type: 'food',
                                id: 'J0sLDQPzNwlOwbxwCn71Yw',
                            }]
                        }
                    ]

                },
                {
                    titleImg:'https://p1.fishqc.net/FkV4KlepYBgF2BEYYRagdwHz8YL-',
                    desc:'日用品安全也是需要关注的重要一环，每天都使用的日用品当然要安全才更安心。',
                    productarr:[
                        {
                            title:'驱蚊水',
                            desc:'天气转热蚊虫增多，驱蚊水必不可少，但劣质驱蚊水含有害成分，可能会有致畸、 致突变等危害，选择安全产品很重要。',
                            product:[{
                                img: 'https://p1.fishqc.net/Fgj2Fu0DK_-4iU_tGTP9N0_m-_wv',
                                brand: "CHICCO智高",
                                title: '婴儿防蚊喷雾',
                                tips: '温和驱蚊',
                                address: '意大利',
                                type: 'cosmetic',
                                id: 'vfEaKQp6pQqg5qa4Drc1pw',
                      
                            },{
                                img: 'https://p1.fishqc.net/FiWNNlPovMAMKGYddKG8rVGL7TRp',
                                brand: "AEROGARD",
                                title: '防蚊水喷雾驱蚊液',
                                tips: '长效驱蚊',
                                address: '英国',
                                type: 'cosmetic',
                                id: '_pO7XJ-QM3WvhYz_PtCYXw',
                            }]
                        },{
                            title:'搓手液',
                            desc:'搓手液不离手的现在，劣质搓手液会让皮肤变得干燥、过敏甚至可能引起接触性皮肤炎，保护家人健康，选择安心搓手液。',
                            product:[{
                                img: 'https://p1.fishqc.net/FlXRlZPfRp4Pzw0X6Wyz96tIULjy',
                                brand: "SAFEGUARD舒肤佳",
                                title: '抑菌免洗洗手液',
                                tips: '有效抑菌',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'mIgBen-ZvNrHEIza7ly7hQ',
                      
                            },{
                                img: 'https://p1.fishqc.net/Fqddb1Y42hJzNzU4l74TMI2CA0H0',
                                brand: "DETTOL滴露",
                                title: '酒精搓手液 经典松木',
                                tips: '免洗除菌',
                                address: '英国',
                                type: 'cosmetic',
                                id: 'xLdMebptwiqp_bR7Gu7n1g',
                            }]
                        },{
                            title:'湿纸巾',
                            desc:'疫情时代，湿纸巾用处多多，但湿纸巾含有毒成分的新闻屡见不鲜，挑选安全湿纸巾更是重中之重。',
                            product:[{
                                img: 'https://p1.fishqc.net/FoWg7wDRSzcn6e5bLxgQXJ3CPSIt',
                                brand: "MANNINGS万宁 ",
                                title: '抗菌湿巾 (无香味)',
                                tips: '杀菌清洁',
                                address: '中国香港',
                                type: 'cosmetic',
                                id: 'Mu08gZ5iqJIirxOugaJ2kw',
                      
                            },{
                                img: 'https://p1.fishqc.net/Fk00xVzRjlSEI_QpIKItAI-jiotm',
                                brand: "RUNBEN润本 ",
                                title: '卫生湿巾',
                                tips: '双重杀菌',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'fn3u3-JcN_ZXmpIMq5-oQg',
                            }]
                        }
                    ]
                },
            ]
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>